<template>
  <v-card class="mb-3">
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12 md7 style="margin-bottom:30px;">
          <v-layout>
            <v-flex shrink>
              <NameDisplay :project="project" />
            </v-flex>
            <v-spacer class="hidden-sm-and-up"></v-spacer>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  v-on="on"
                  flat
                  icon
                  v-if="dialogController != undefined"
                >
                  <v-icon small>fas fa-ellipsis-v</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile @click="onEditName">
                  <v-list-tile-action>
                    <v-icon small color="primary">fas fa-pen</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title> Name</v-list-tile-title>
                </v-list-tile>

                <v-list-tile @click="onEditGoal">
                  <v-list-tile-action>
                    <v-icon small color="primary">fas fa-pen</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title> Goal</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="onRemove">
                  <v-list-tile-action>
                    <v-icon small color="red">far fa-trash-alt</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title> Delete</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-layout>
        </v-flex>

        <v-flex xs12 md5 style="direction:rtl; margin-bottom:30px;">
          <CalendarHeatMap
            :color="project.data.color"
            :recordCache="recordCache"
            :config="{
              domainMargin: 5,
              range: 3,
              start: -3,
              displayLegend: true,
              legendOrientation: 'vertical',
              legendVerticalPosition: 'center',
              legendHorizontalPosition: 'right',
              legendMargin: [28, 0, 0, 10]
            }"
          />
        </v-flex>
      </v-layout>

      <v-layout style="margin-bottom:30px">
        <StatusDisplay :project="project" />
      </v-layout>

      <v-btn
        round
        color="primary"
        v-if="projectId != undefined && project.isDuration()"
        :to="{
          name: 'projectTimerView',
          params: { projectId }
        }"
      >
        <v-icon left>far fa-clock</v-icon> Timer
      </v-btn>

      <v-btn
        round
        v-if="projectId != undefined && project.isCounter()"
        :to="{
          name: 'projectCheckInView',
          params: { projectId }
        }"
        color="primary"
      >
        <v-icon small left>fas fa-check</v-icon> Check In
      </v-btn>

      <v-btn
        round
        color="red"
        dark
        v-if="projectId != undefined && project.isFailure()"
        @click="project.restart()"
      >
        <v-icon small left>fas fa-redo</v-icon> Restart
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import CalendarHeatMap from "@/components/CalendarHeatMap";
import NameDisplay from "./NameDisplay";
import StatusDisplay from "./StatusDisplay";
import { Project } from "@/classes/Project/Project";
import { RecordCache } from "@/classes/RecordCache/RecordCache";
import { DialogController } from "@/classes/DialogController";
export default {
  props: {
    project: {
      type: Project
    },
    recordCache: {
      type: RecordCache
    },
    dialogController: DialogController
  },
  components: {
    CalendarHeatMap,
    StatusDisplay,
    NameDisplay
  },
  computed: {
    projectId() {
      return this.$route.params.projectId;
    }
  },
  methods: {
    onEditName() {
      this.dialogController.open(this.project, { step: 2 });
    },
    onEditGoal() {
      this.dialogController.open(this.project, { step: 3 });
    },
    onRemove() {
      this.project.remove();
      this.$router.push({ name: "home" });
    }
  }
};
</script>
